<template>
  <div class="row">
    <div class="col-12">
      <div class="mention-input" :style="d_mentionInputStyles">
        <div :class="d_containerClass" :style="d_containerStyles">
          <div :class="d_mainContainerClass" :style="d_mainContainerStyles">
            <div class="mention-input__input-container" @focus="handleFocus">
              <vue-editor ref="editor" :editorOptions="d_editorOptions" @focus="handleFocus" @input="handleInput"
                @blur="handleBlur" v-model="value" :placeholder="placeholder">
              </vue-editor>
            </div>
          </div>
        </div>
      </div>
      <div class="user-sugestions-area">
        <span class="avatar-xs avatar-mini">
          <span class="avatar-title rounded-circle bg-azul">
            <i class="fas fa-user-plus"></i>
          </span>
        </span> <span class="font-size-12">Digite @ para marcar outros membros.</span>
      </div>
      <button type="button" class="btn btn-xs btn-primary bg-gray mt-2" @click="sendComment">Comentar</button>
    </div>
    <div class="col-12">
      <p v-if="isLoading">Aguarde carregando comentários...</p>
      <ul class="comment-items" v-if="comments.length > 0">
        <li v-for="comment in comments" :key="comment.id">
          <div class="d-flex align-items-start">
            <app-avatar-admin :name="comment.user.name" class="d-flex me-3 avatar-mini" />
            <div class="flex-1 chat-user-box">
              <p class="user-title m-0 mt-1">
                {{ comment.user.name }}
                <span class="float-right">{{ comment.created_at | dateString('dd/mm hh:ii') }}</span>
              </p>
              <p class="m-0 mt-2 wrap-mode comment-text" v-html="comment.description"></p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppAvatarAdmin from "@/components/AppAvatarAdmin/AppAvatarAdmin.vue";
import { VueEditor } from "vue2-editor";
import "quill-mention";
import _ from "lodash";

function isNode(v, title = "GLOBALS.NODE.ISNODE") {
  if (v instanceof Element) return true;
  return !!console.error(new Error(`ERR::${title}! ${v} is not a node`));
}

function componentBlurred(container) {
  if (!isNode(container, "GLOBALS.EVENT.COMPONENTBLURRED")) return false;
  if (!container.contains(document.activeElement)) return true;
  return false;
}

function checkItemClickedForBlur() {
  if (componentBlurred(this.$el)) {
    this.d_focus = false;
    this.$emit("input", { value: this.value, mentions: this.d_mentions });
    this.$emit("blur");
  }
}

export default {
  name: "mentionInput",
  components: { VueEditor, AppAvatarAdmin },
  props: {
    id: {
      type: Number,
      required: true
    },
    users: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      d_focus: false,
      d_setvalue: !!this.value,
      d_mentions: [],
      value: "",
      placeholder: "Comentar...",
      inline: false,
      slim: false,
      customToolbar: [['bold', 'italic', 'underline', 'link']],
      total: 0,
      comments: [],
      isLoading: true,
      newComment: [],
    };
  },
  computed: {
    d_editorOptions() {
      const { d_atValues } = this;
      return {
        theme: null,
        modules: {
          toolbar: this.customToolbar,
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: function (searchTerm, renderList) {
              const values = d_atValues;

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value
                      .toLowerCase()
                      .indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            },
          },
        },
      };
    },
    d_atValues() {
      return this.users.map(el => {
        return {
          id: el.id,
          value: el.name
        }
      })
    },
    d_textAreaPadding() {
      const setValue = this.d_setvalue ? "1px" : null;
      return this.d_focus ? "2px" : setValue;
    },
    d_mainContainerClass() {
      const { inline, slim } = this;
      const out = [`mention-input__main-container`];
      if (inline) {
        out.push(`mention-input--inline`);
      }
      if (slim) {
        out.push(`mention-input__main-container--slim`);
      }
      return out;
    },
    d_mentionInputStyles() {
      return {
        zIndex: this.d_focus ? 1 : 0,
        paddingBottom: this.d_textAreaPadding,
      };
    },
    d_containerClass() {
      const container = [`mention-input__container`];
      if (this.d_focus) {
        const focusClass = this.slim
          ? `mention-input__container--focused-slim`
          : `mention-input__container--focused`;
        container.push(focusClass);
      }
      return container;
    },
    d_containerStyles() {
      return { marginBottom: this.d_focus || this.d_setvalue ? "-1px" : null };
    },
    d_mainContainerStyles() {
      return {
        paddingBottom: this.padded ? `${this.padded}px` : null,
        fontWeight: this.bolded ? "600" : null,
      };
    },
  },
  created() {
    this.initializeData();
  },
  mounted() {
    this.attachQuillPasteHandler()
  },
  methods: {
    ...mapActions([
      "showMessage",
    ]),
    setFocus() {
      this.d_focus = true;
      this.$nextTick(() => {
        if (this.$refs && this.$refs.editor && this.$refs.editor.quill) {
          this.$refs.editor.quill.focus();
        }
      });
    },
    handleFocus(e) {
      if (this.$el && !this.$el.contains(document.activeElement))
        this.$emit("focus");
      const { target } = e;
      this.d_focus = true;
      // if(!this.d_setvalue) this.d_computedheight = getNearestSpacing(this.height);
      this.$nextTick(() => {
        if (
          target !== this.$refs.textarea &&
          this.$refs &&
          this.$refs.editor &&
          this.$refs.editor.quill
        ) {
          this.$refs.editor.quill.focus();
        }
      });
    },
    getMentions: function () {
      var marvelDelta = this.$refs.editor.quill.editor.delta;
      var mentionDelta = _.filter(marvelDelta.ops, "insert.mention");
      var mentions = _.map(mentionDelta, function (value) {
        return _.toInteger(_.get(value, "insert.mention.id"));
      });
      return mentions;
    },
    handleBlur() {
      setTimeout(checkItemClickedForBlur.bind(this), 0);
    },
    handleInput(v) {
      if (!v) return;
      this.$nextTick(() => {
        this.newComment = {
          value: this.value,
          mentions: this.d_mentions
        }
      });
    },
    ...mapActions(["showMessage"]),
    async sendComment() {
      if (this.isLoading) return;
      if (this.newComment.length === 0) return;
      const data = {
        description: this.newComment.value
          .replace(/&nbsp;/gi, '')
          .trim(),
        mentionedUsers: this.newComment.mentions
      };
      const response = await this.$AppCallApi("POST", `f-task-comment/${this.id}`, data);
      if (response.status === 200) {
        if (response.data && response.data.data) {
          this.comments = [...response.data.data, ...this.comments];
          this.total = this.comments.length;
          //Limpar
          this.value = "";
          this.showMessage({
            title: 'Sucesso.',
            css: "bg-success"
          })
        }
      }
      else {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }
    },
    async initializeData() {
      const response = await this.$AppCallApi("GET", `f-task-comments/${this.id}`);
      if (response.status === 200) {
        if (response.data && response.data.data) {
          const apiData = response.data.data;
          this.comments = apiData.items || [];
          this.total = apiData.total || 0;
        }
        this.isLoading = false;
      } else {
        this.showMessage({
          title: "Desculpe um erro aconteceu ao ler os comentários da tarefa.",
          css: "bg-danger"
        });
      }
    },
    displayError(error) {
      this.showMessage({
        title: error.response.data.message,
        text: this.$root.$options.filters.objectError(
          error.response.data.errors
        ),
        css: "bg-danger"
      });
    },
    detectLinksAndConvert(text) {
      const urlRegex = /(https?:\/\/[^\s<>"']+)/gi;
      console.log('text', text)
      text.replace(urlRegex, match => {
        const trailingChars = [".", ",", ";", "!", "?", ")", "]"];
        let cleanUrl = match;
        let trail = "";

        while (trailingChars.includes(cleanUrl.slice(-1))) {
          trail = cleanUrl.slice(-1) + trail;
          cleanUrl = cleanUrl.slice(0, -1);
        }

        return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>${trail}`;
      });

      return text.replace(/\u2028/g, '<br />')
        .replace(/\r\n/g, '<br />')
        .replace(/\n/g, '<br />')
        .replace(/\r/g, '<br />');
    },
    attachQuillPasteHandler() {
      const quill = this.$refs.editor.quill;
      quill.root.addEventListener('paste', (e) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text');
        const htmlTextWithLinks = this.detectLinksAndConvert(pastedText);
        const selection = quill.getSelection(true);
        quill.clipboard.dangerouslyPasteHTML(selection.index, htmlTextWithLinks);
      });
    }
  },
  watch: {
    value: {
      handler(v) {
        if (!v) return
        this.$nextTick(() => {
          const { editor } = this.$refs;
          if (editor) {
            this.d_mentions = this.getMentions();
          }
        });
      },
    },
  },
};
</script>


<style>
.user-sugestions-area {
  position: relative;
  float: left;
  width: 100%;
  height: 40px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: 10px;
  border: 1px solid #d2d6da;
}

.ql-toolbar {
  border: 1px solid #d2d6da;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.ql-toolbar,
.ql-formats,
.ql-container,
.ql-formats>button {
  position: relative;
  float: left;
  width: 100%;
}

.ql-formats>button {
  width: 40px;
  height: 40px;
  border: 1px solid transparent;
  border-right: 1px solid #d2d6da;
  background: transparent;
  border-bottom: none;
  opacity: .8;

}

.ql-editor {
  min-height: 140px;
  font-size: 15px;
}

.ql-formats>button:first-child {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.ql-container {
  border-left: 1px solid #d2d6da;
  border-right: 1px solid #d2d6da;
  color: #495057;
}

.ql-editor.ql-blank::before {
  color: #495057;
}

.ql-formats>button:hover,
.ql-formats>button:hover::before {
  opacity: 1;
}

.ql-bold::before,
.ql-italic::before,
.ql-underline::before,
.ql-link::before {
  position: absolute;
  float: left;
  width: 40px;
  height: 40px;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: 16px;
  content: "";
  left: 0px;
  top: 0px;
  line-height: 40px;
  color: #495057;
  opacity: .8;
}

.ql-bold::before {
  content: "\f264";

}

.ql-italic::before {
  content: "\f277";
}

.ql-link::before {
  content: "\f337";
}


.ql-underline::before {
  content: "\f287";
}

.ql-mention-list-container {
  width: 270px;
  border: 1px solid #F0F0F0;
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 12px 0 rgba(30, 30, 30, 0.08);
  z-index: 9001;
}

.ql-mention-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.ql-mention-list-item {
  cursor: pointer;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  padding: 0 20px;
  vertical-align: middle;
}

.ql-mention-list-item.selected {
  background-color: #D3E1EB;
  text-decoration: none;
}

.mention {
  height: 24px;
  width: 65px;
  border-radius: 6px;
  background-color: #f1f2f4;
  padding: 3px 0;
}

.mention>span {
  margin: 0 3px;
}


.float-right {
  float: right;
}

.chat-user-box {
  overflow: hidden !important;
}

.chat-user-box p {
  font-size: 14px;
}

.wrap-mode {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
}

ul.comment-items li .user-title {
  color: #8687a7;
}


.bg-azul {
  background: #0066ff;
  color: #ffff;
}

ul.comment-items {
  list-style: none;
  margin: 30px 0px 0px 0px;
  padding: 0px;
}

ul.comment-items li:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

ul.comment-items li:last-child {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

ul.comment-items li {
  list-style: none;
  padding: 10px;
  margin-top: 0;
  background: #ffff;
  border-bottom: 1px solid #f1f2f4;
  border-left: 1px solid #f1f2f4;
  border-right: 1px solid #f1f2f4;
}

ul.comment-items li:nth-child(odd) {
  background: rgb(241, 242, 244);
}

ul.comment-items li p {
  color: rgba(0, 0, 0, .5);
}

ul.comment-items li p.comment-text>span {
  color: #0066ff !important;
}

ul.comment-items li p.comment-text>a {
  color: #0066ff;
  text-decoration: underline !important;
}

.comment-items .avatar-mini {
  width: 30px;
  height: 30px;
  font-size: 12px;
}

.comment-text>p {
  margin: 0px !important;
}
</style>